import React from 'react'
import SliderAbout4Sec1 from './SliderAbout4Sec1/SliderAbout4Sec1'
import SliderAbout4Sec2 from './SliderAbout4Sec2/SliderAbout4Sec2'

function SliderAbout4() {
  return (
    <>
      <SliderAbout4Sec1 />
      <SliderAbout4Sec2 />
    </>
  )
}

export default SliderAbout4
